
import Vue from 'vue'
import {Action} from 'vuex-class'
import {Component, Prop} from 'vue-property-decorator'
import InvoiceDetailTab from '@/components/invoice-detail/InvoiceDetailTab.vue'
import {FETCH_INVOICE_DETAIL} from '@/store/action-types'
import {Invoice} from '@/model/Invoice'

@Component({
  components: {
    InvoiceDetailTab
  }
})
export default class InvoiceDetailDialog extends Vue {
  @Prop({type: Boolean, default: false}) readonly show!: boolean
  @Prop({type: Object, required: true}) readonly invoice!: Invoice

  @Action(FETCH_INVOICE_DETAIL) fetchInvoiceDetail!: ({ (payload: Invoice): Promise<Invoice> })

  private fetchInProgress = false
  private invoiceDetail: Invoice | null = null
  private tab: number | null = null

  onCloseButtonClick(): void {
    this.$emit('close')
  }

  async fetchData() {
    try {
      this.fetchInProgress = true
      this.invoiceDetail = await this.fetchInvoiceDetail(this.invoice)

      console.debug(this.invoiceDetail)
    } catch (e) {
      // TODO
    } finally {
      this.fetchInProgress = true
    }
  }

  mounted(): void {
    this.fetchData()
  }
}
